module.exports = __webpack_public_path__ + "static/img/3578_phase_function_Paper_Points.577aff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3578_phase_function_Paper_Points.png
// module id = 4Kvs
// module chunks = 0